import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyTooltip } from '@vendasta/galaxy/tooltip';

@Component({
  selector: 'crm-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatIconModule, GalaxyBadgeModule, GalaxyTooltip],
})
export class TagsComponent {
  @Input() tags: string[] = [];
}
